import Modal from 'utils/packages/Modal';
import { StyleSheet, View } from 'react-native';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconEdit, IconTrash } from 'design-system/icons';
import React from 'react';
import { rem } from 'design-system/values';
import { isWeb } from '../constants';
export const EditDeleteModal = {
    show: ({ key, onDelete, onEdit, options = {}, }) => {
        Modal.show(<View style={styles.modalContent}>
        <SettingsItem icon={<IconEdit gradientKey="lightPink"/>} title="Edit" onPress={() => {
                onEdit?.(key);
                Modal.hide();
            }}/>
        <SettingsItem icon={<IconTrash colorKey="negative"/>} title="Delete" onPress={() => {
                onDelete?.(key);
                Modal.hide();
            }}/>
      </View>, {
            containerStyle: styles.modal,
            title: 'Edit goal',
            ...options,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
        // Replaces the web modal's own 16px, so the last row sits 8px from the bottom
        ...(isWeb && { paddingBottom: rem(8) }),
    },
    modalContent: {
        paddingVertical: rem(20),
        // On web the rows' hover highlight sits inside the modal, as on cards
        ...(isWeb && {
            paddingBottom: 0,
            paddingHorizontal: rem(8),
        }),
    },
    content: {
        paddingTop: rem(16),
        paddingBottom: rem(100),
    },
    noGoalsCard: {
        marginVertical: 0,
        padding: rem(16),
        justifyContent: 'center',
        alignItems: 'center',
    },
    noGoalsTextContainer: {
        alignItems: 'center',
        marginVertical: rem(16),
    },
    secondaryButton: {
        height: rem(34),
        alignSelf: 'center',
        minWidth: rem(129),
    },
});
